(() => {
  if (window.projectMasonryInitialized) return;
  window.projectMasonryInitialized = true;

  class ProjectMasonry {
    constructor(element) {
      this.element = element;
      this.cards = Array.from(element.querySelectorAll(':scope > .project-card'));
      this.pagination = element.querySelector(':scope > .project__pagination');
      this.frame = null;
      this.width = 0;

      if (this.cards.length === 0) return;

      this.resizeObserver = new ResizeObserver(([entry]) => {
        const width = entry.contentRect.width;
        if (Math.abs(width - this.width) < 0.5) return;
        this.width = width;
        this.schedule();
      });
      this.resizeObserver.observe(element);

      for (const image of element.querySelectorAll('img')) {
        if (!image.complete) image.addEventListener('load', () => this.schedule(), { once: true });
      }

      if (document.fonts?.ready) document.fonts.ready.then(() => this.schedule());
      this.schedule();
    }

    schedule() {
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.layout());
    }

    layout() {
      this.frame = null;
      const styles = getComputedStyle(this.element);
      const columns = Math.max(1, Number.parseInt(styles.getPropertyValue('--project-column-count'), 10) || 1);
      const rowHeight = Number.parseFloat(styles.gridAutoRows) || 1;

      this.element.classList.add('project__artworks--masonry');

      for (const [index, card] of this.cards.entries()) {
        card.style.gridColumn = String((index % columns) + 1);
        card.style.gridRowStart = 'auto';
        card.style.gridRowEnd = 'auto';
      }

      void this.element.offsetWidth;

      const spans = this.cards.map((card) => {
        const margin = Number.parseFloat(getComputedStyle(card).marginBlockEnd) || 0;
        return Math.ceil((card.getBoundingClientRect().height + margin) / rowHeight);
      });
      const nextRows = Array(columns).fill(1);

      for (const [index, card] of this.cards.entries()) {
        const column = index % columns;
        const span = spans[index];
        card.style.gridRowStart = String(nextRows[column]);
        card.style.gridRowEnd = `span ${span}`;
        nextRows[column] += span;
      }

      if (this.pagination) {
        this.pagination.style.gridRowStart = String(Math.max(...nextRows));
        this.pagination.style.gridRowEnd = 'auto';

        void this.element.offsetWidth;

        const paginationStyles = getComputedStyle(this.pagination);
        const paginationMargin =
          (Number.parseFloat(paginationStyles.marginBlockStart) || 0) +
          (Number.parseFloat(paginationStyles.marginBlockEnd) || 0);
        const paginationSpan = Math.ceil(
          (this.pagination.getBoundingClientRect().height + paginationMargin) / rowHeight
        );
        this.pagination.style.gridRowEnd = `span ${paginationSpan}`;
      }
    }
  }

  const syncAvailabilityView = (root) => {
    const parameters = new URLSearchParams(window.location.search);
    const availableNow = parameters
      .getAll('filter.p.m.custom.print_availability')
      .includes('Available for Purchase');
    const showAll = parameters.get('print_scope') === 'all';

    for (const toggle of root.querySelectorAll('[data-project-view-toggle]')) {
      for (const link of toggle.querySelectorAll('[data-project-view]')) {
        const isCurrent = link.dataset.projectView === (availableNow ? 'available' : 'all');
        if (isCurrent) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }
    }

    if (showAll) {
      for (const link of root.querySelectorAll('.project__pagination a')) {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('print_scope', 'all');
        link.href = url.toString();
      }
    }

    if (availableNow) {
      for (const emptyMessage of root.querySelectorAll('[data-project-empty]')) {
        emptyMessage.textContent = 'No edition prints are currently available.';
      }
    }
  };

  const initialize = (root = document) => {
    syncAvailabilityView(root);
    for (const element of root.querySelectorAll('[data-project-masonry]')) {
      if (element.projectMasonry) continue;
      element.projectMasonry = new ProjectMasonry(element);
    }
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
